import { render, staticRenderFns } from "./NewFieldForm.vue?vue&type=template&id=476d2c64&"
import script from "./NewFieldForm.vue?vue&type=script&lang=js&"
export * from "./NewFieldForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports